import MainLayout from "@/components/layouts/MainLayout"
import HelpPage from "@/components/pages/HelpPage"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import { ReactElement } from "react"

const Page = () => <HelpPage />

Page.getLayout = function getLayout(page: ReactElement) {
  return <MainLayout>{page}</MainLayout>
}

export async function getStaticProps({ locale }) {
  const translations = await serverSideTranslations(locale, ["common", "auth", "validations"])

  return {
    props: {
      ...translations,
    },
  }
}

export default Page
